module.exports = ".no-padding{\n    padding: 0;\n}\n\n.videoContainer{\n    height: 90%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/video-dialog/video-dialog.component.css
// module id = ./src/app/video-dialog/video-dialog.component.css
// module chunks = main